import React from 'react'
import {
  Box,
  Button,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import CardEvent from '../../Component/Cards/CardEvent'
import { useLocation, useNavigate } from 'react-router-dom'

const Events = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const get_Data = props.Event_DATA
  const location = useLocation()
  const navigate = useNavigate()
  const { pathname } = location

  const navigateToActivitiesPage = (department) => {
    if (pathname === '/home' || pathname === '/') {
      navigate(`/departmentalactivities/2`, {
        state: { id: department.id, title: department.page_name },
      })
    } else {
      navigate(`${pathname}/subject-activities`)
    }
  }

  return (
    <Box
      sx={{
        mt: 8,
        py: 6,
        px: isMobile ? 2 : 4,
        backgroundColor: theme.palette.background.primary,
        transition: 'box-shadow 0.3s ease-in-out',
      }}
    >
      {get_Data.length === 0 ? null : (
        <>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 4 }}
          >
            <Grid item xs={12} sm={8} md={9}>
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.text.primary,
                  [theme.breakpoints.down('md')]: {
                    fontSize: '1.75rem',
                  },
                }}
              >
                {props.title}
              </Typography>
              {props.subtitle && (
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: theme.palette.text.secondary,
                    mt: 1,
                  }}
                >
                  {props.subtitle}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              sx={{
                textAlign: { xs: 'left', sm: 'right' },
                display: 'flex',
                justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                    borderColor: theme.palette.primary.dark,
                  },
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  fontWeight: 600,
                }}
                onClick={() => navigateToActivitiesPage(props.totalData)}
              >
                View All
              </Button>
            </Grid>
          </Grid>

          <CardEvent getdata={get_Data.slice(0, isMobile ? 1 : 3)} />

          {get_Data.length > 3 && !isMobile && (
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Button
                variant="text"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => navigateToActivitiesPage(props.totalData)}
              >
                Load More Events
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  )
}

export default Events
